import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

export const StyledProfileWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  top: 66px;
  z-index: 1;
`;
export const StyledProfileName = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media ${MEDIA_QUERIES.MOBILE} {
    padding-top: 20px;
  }
`;

export const StyledMobileWrapper = styled.div`
  @media ${MEDIA_QUERIES.MOBILE} {
    margin-top: -3.5rem;
  }
`;

export const StyledProfileNameTag = styled.div`
  width: 120px;
  height: 120px;

  display: flex;
  justify-content: center;
  align-items: center;

  margin: 10px 0 10px 10px;
  padding: 9px;

  background-color: ${DIGIPOSTHEME.colors.footerGrey};

  font-size: 20px;
  color: ${DIGIPOSTHEME.colors.red};
  font-weight: 700;
  font-family: Campton;

  border: 2px solid ${DIGIPOSTHEME.colors.primaryAkbankWhite};
  border-radius: 50%;

  @media ${MEDIA_QUERIES.MOBILE} {
    margin: 0;
    padding: 6px;
  }
`;

export const StyledProfileBox = styled.div`
  width: 200px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #f5f4f6;
  border-radius: 5px;
  box-shadow: rgb(0 0 0 / 25%) 1px 1px 1px;
  margin: 10px 15px 0 0;

  @media ${MEDIA_QUERIES.MOBILE} {
    width: 100%;
    padding: 5px;
    margin: 0;
  }
`;

export const StyledProfileText = styled.p`
  font-family: "Campton";
  font-size: "18px";
  text-align: "18px";
  font-weight: "300";
  text-transform: "none";
  cursor: pointer;
  letter-spacing: "0.1px";
  color: ${DIGIPOSTHEME.colors.black};
  pointer-events: none;
`;

export const StyledProfileCircleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80px;
  align-items: center;
`;

export const StyledProfileIconCircle = styled.div`
  border-radius: 50%;
  background-color: ${DIGIPOSTHEME.colors.transparent};
  border: 1px solid #f5f4f6;
  box-shadow: rgb(0 0 0 / 14%) 0px 2px 2px 1px;
  padding: 10px;
  width: 52px;
  height: 52px;
  display: flex;
  justify-content: center;
  cursor: pointer;

  &:active {
    transform: scale(0.9);
  }
  &:hover {
    box-shadow: rgb(136 8 8 / 74%) 0px 2px 2px 1px;
  }

  @media ${MEDIA_QUERIES.MOBILE} {
    width: 48px;
    height: 48px;
  }
`;

export const StyledProfileBoxImage = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 10px;
`;
